import { Chip, Stack, Typography } from "@mui/material";
import IconBtn from "components/lib-ui/IconBtn";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DialogBox from "components/lib-ui/DialogBox";
import { useState } from "react";
import LanguagesForm from "./LanguageForm";
export default function LanguageField({ languages }) {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [languagesState , setLanguagesState] = useState(languages || null);
    
    const handleDialogOpen = () => {
        setIsDialogOpen(true);
    };
    return (
        <Stack spacing={1} sx={{ gridColumn: "span 4" }}>
            <Stack
                direction="row"
                spacing={1}
                alignItems={"center"}
                sx={{
                    position: "relative",
                }}
            >
                <Typography
                    variant="subtitle1"
                    sx={{
                        fontWeight: 400,
                        fontSize: "0.75rem",
                        color: "rgba(0, 0, 0, 0.6)",
                        textAlign: "left",
                    }}
                >
                    Languages
                </Typography>
                <IconBtn
                    sx={{
                        opacity: 1,
                        marginLeft: "auto",
                        border: "unset",
                        background: "white",
                    }}
                    icon={EditOutlinedIcon}
                    onClick={handleDialogOpen}
                ></IconBtn>
            </Stack>
            {languagesState && languagesState.length > 0 ? (
                <Stack direction="row" gap={1} flexWrap="wrap">
                    {languagesState.map((language, index) => (
                        <Chip
                            key={index}
                            label={`${language.language.name} - ${language.language_level.name}`}
                            color="primary"
                        />
                    ))}
                </Stack>
            ) : (
                <Typography variant="body2">
                    No languages information available.
                </Typography>
            )}
            <DialogBox
                isDialogOpen={isDialogOpen}
                setIsDialogOpen={setIsDialogOpen}
                title="Add Languages"
                floatCancel={true}
                showActionButtons={false}
            >
                <LanguagesForm
                    setIsDialogOpen={setIsDialogOpen}
                    language={languagesState}
                    setLanguage={setLanguagesState}
                />
            </DialogBox>
        </Stack>
    );
}
